import { ArrowUpIcon } from '../icons/arrow_up_icon.component';
import { ArrowDownIcon } from '../icons/arrow_down_icon.component';

interface ButtonProp {
  isSeeMore: boolean;
  onClick: () => void;
  t: ( key: string ) => string;
};


export function SeeMore( { isSeeMore, onClick, t }: ButtonProp ) {

  return (
    <div
      className='flex h-fit w-fit mx-2 my-1'
      onClick={ onClick }
    >
      <span
        className='flex text-blue-600 hover:text-blue-800 fill-blue-600 hover:fill-blue-800 cursor-pointer'
      >
        {
          isSeeMore ?
            <div className='flex w-full items-center gap-1'>{ t( 'See less' ) } <ArrowUpIcon className='w-[16px]'/></div>
            :
            <div className='flex w-full items-center gap-1'>{ t( 'See more' ) } <ArrowDownIcon className='w-[16px]'/></div>
        }
      </span>
    </div>
  );
};